// @flow
import env from '../../../environment';
import {
  postCreator,
  getCreator,
  putCreator,
  deleteCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  UPDATE_PAYMENT_METHOD: `${env.baseApiUrl}/checkout/admin/store-payment-provider/others/:id`,
  UPDATE_CONTINUE_TO_CHAT: `${env.baseApiUrl}/checkout/admin/store-payment-provider/continue-to-chat`,
  UPDATE_PAY_ON_DELIVERY: `${env.baseApiUrl}/checkout/admin/store-payment-provider/pay-on-delivery`,
  ADD_PAYMENT_METHOD: `${env.baseApiUrl}/checkout/admin/store-payment-provider/others`,
  DELETE_PAYMENT_METHOD: `${env.baseApiUrl}/checkout/admin/store-payment-provider/:id`,
  GET_PAYMENT_METHODS: `${env.baseApiUrl}/checkout/admin/store-payment-provider`,
  GET_MY_PAYMENT_METHOD: `${env.baseApiUrl}/checkout/admin/store-payment-provider/:id`,
  UPDATE_MERCADOPAGO_CHECKOUT_PRO: `${env.baseApiUrl}/checkout/admin/store-payment-provider/mercadopago-checkout-pro`,
  UPDATE_IZIPAY: `${env.baseApiUrl}/checkout/admin/store-payment-provider/izipay`,
  UPDATE_CULQI: `${env.baseApiUrl}/checkout/admin/store-payment-provider/culqi`,
  UPDATE_STRIPE: `${env.baseApiUrl}/checkout/admin/store-payment-provider/stripe-checkout`,
  UPDATE_PAYPAL: `${env.baseApiUrl}/checkout/admin/store-payment-provider/paypal`,
  UPDATE_TRANSBANK: `${env.baseApiUrl}/checkout/admin/store-payment-provider/transbank`,
  UPDATE_NIUBIZ_PAY_LINK: `${env.baseApiUrl}/checkout/admin/store-payment-provider/niubiz-pay-link`,
  UPDATE_NIUBIZ_WEB: `${env.baseApiUrl}/checkout/admin/store-payment-provider/niubiz-web`,
});

export const updateContinueToChatApi = putCreator(
  endpoints.UPDATE_CONTINUE_TO_CHAT
);

export const updatePayOnDeliveryApi = putCreator(
  endpoints.UPDATE_PAY_ON_DELIVERY
);

export const updatePaymentMethodApi = putCreator(
  endpoints.UPDATE_PAYMENT_METHOD
);
export const addPaymentMethodApi = postCreator(endpoints.ADD_PAYMENT_METHOD);
export const deletePaymentMethodApi = deleteCreator(
  endpoints.DELETE_PAYMENT_METHOD
);
export const getPaymentMethodsApi = getCreator(endpoints.GET_PAYMENT_METHODS);

export const getPaymentMethodApi = getCreator(endpoints.GET_MY_PAYMENT_METHOD);
export const updateMercadoPagoCheckoutProApi = putCreator(
  endpoints.UPDATE_MERCADOPAGO_CHECKOUT_PRO
);
export const updateIziPayApi = putCreator(endpoints.UPDATE_IZIPAY);
export const updateCulqiApi = putCreator(endpoints.UPDATE_CULQI);
export const updateStripeApi = putCreator(endpoints.UPDATE_STRIPE);
export const updatePaypalApi = putCreator(endpoints.UPDATE_PAYPAL);
export const updateTransbankApi = putCreator(endpoints.UPDATE_TRANSBANK);
export const updateNiubizPayLinkApi = putCreator(
  endpoints.UPDATE_NIUBIZ_PAY_LINK
);
export const updateNiubizWebApi = putCreator(endpoints.UPDATE_NIUBIZ_WEB);
